import { skipToken, useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchMarket } from '#/api/apiExchange';
import { useWebsocketEventListener } from '#/components/hooks';
import { RELOAD_MARKETS_DELAY_MS } from '#/config/constants';
import useEventCallback from '#/hooks/useEventCallback';

import { minutes, seconds } from './utils';

function useInvalidateMarketsQueries() {
  const queryClient = useQueryClient();
  return useEventCallback(() =>
    queryClient.invalidateQueries({ queryKey: ['markets'] })
  );
}

export const useGlobalMarketsQueriesInvalidator = () => {
  const invalidateMarketsQueries = useInvalidateMarketsQueries();
  useWebsocketEventListener('webclient', message => {
    if (
      message.data.event === 'exchange_status_updated' &&
      message.data.action?.includes('market')
    ) {
      setTimeout(() => {
        invalidateMarketsQueries();
      }, RELOAD_MARKETS_DELAY_MS);
    }
  });
};

export const useMarketQuery = (market?: string) => {
  return useQuery({
    queryKey: ['markets', market],
    queryFn: !market
      ? skipToken
      : () => fetchMarket(market).then(data => data[0]),
    staleTime: seconds(30),
    refetchOnWindowFocus: false,
    refetchInterval: minutes(15),
  });
};
